import pokeDex from "../images/PokeDex.JPG";
import netflixLogo1 from "../images/netflixLogo1.JPG";
import loginFormPage from "../images/LoginFormPage.JPG";
import expenses from "../images/ExpensesTracker.JPG";
import WeatherForcast from "../images/WeatherForcast.JPG";
import landingPage from "../images/landingpage.JPG";

export const projectsData = [
  {
    id: 0,
    img: WeatherForcast,
    title: "5 Days Weather Forcast",
    description:
      "Using the OpenWeatherMap API to get the weather forcast for 5 days for a chosen city or your current location.",
    url: "https://mizweatherapp.netlify.app/",
  },
  {
    id: 1,
    img: netflixLogo1,
    title: "Netflix Clone",
    description:
      "Netflix Clone using IMDB API and MUI V5",
    url: "https://mizflix.netlify.app/",
  },
 
  {
    id: 2,
    img: landingPage,
    title: "Landing Page",
    description:
      "Using React, StyledComponents and MUIv5, to create a landing page",
    url: "https://github.com/Zulgix/react_landing_page",
  },
  {
    id: 3,
    img: pokeDex,
    title: "PokeDex",
    description:
      "Using pokemon api to get the data and attributes of a pokemon and display it",
    url: "https://github.com/Zulgix/PokeDEx",
  },

  {
    id: 4,
    img: expenses,
    title: "Expenses Tracker",
    description:
      "Expenses tracker and filtering the expenses based on the year that the expense was made",
    url: "https://github.com/Zulgix/expanses_tracker",
  },
  {
    id: 5,
    img: loginFormPage,
    title: "Validated Login Form",
    description:
      "Using React Hooks to validate the login form and Redux to store the user data",
    url: "https://github.com/Zulgix/form-validation-with-hooks",
  },

];
